import { Link, LinkProps } from '@backstage/core-components';
import { IconComponent } from '@backstage/core-plugin-api';
import { IconText } from './IconText';

export const IconLink = (
  props: {
    Icon: IconComponent;
    text: string;
  } & LinkProps,
) => {
  return (
    <Link {...props}>
      <IconText {...props} />
    </Link>
  );
};
